import type * as models from './models'

export interface State {
  readonly suggestedQuestions: readonly string[]
  readonly suggestedQuestionsRequest: {
    readonly isLoading: boolean
    readonly error?: Error
  }
  readonly messages: readonly models.Message[]
  readonly ask: {
    readonly isSubmitting: boolean
    readonly error?: Error
  }
}
export namespace State {
  export const INITIAL: State = {
    ask: {
      isSubmitting: false,
    },
    messages: [],
    suggestedQuestions: [],
    suggestedQuestionsRequest: {
      isLoading: false,
    },
  }
}
